import React from "react";

import { ClientsDashboardProvider } from "./context/clients-dashboard-context";
import ClientsDashboardComponent from "./clients-dashboard";

const ClientsDashboard: React.FC = () => {
  return (
    <ClientsDashboardProvider>
      <ClientsDashboardComponent />
    </ClientsDashboardProvider>
  );
};

export default ClientsDashboard;
